// Non-delivery dates (initial set): union of UK bank/public holidays for
// England & Wales, Scotland and Northern Ireland for 2025 and 2026.
// Dates are local and in YYYY-MM-DD format.
export const NonDeliveryDates: string[] = [
  // 2025
  '2025-01-01', // New Year's Day
  '2025-01-02', // 2nd Jan (Scotland)
  '2025-03-17', // St Patrick's Day (Northern Ireland)
  '2025-04-18', // Good Friday
  '2025-04-21', // Easter Monday
  '2025-05-05', // Early May bank holiday
  '2025-05-26', // Spring bank holiday
  '2025-07-14', // Battle of the Boyne (substitute) - Northern Ireland
  '2025-08-04', // Summer bank holiday (Scotland)
  '2025-08-25', // Summer bank holiday (England/Wales/Northern Ireland)
  '2025-12-01', // St Andrew's Day (substitute) - Scotland
  '2025-12-25', // Christmas Day
  '2025-12-26', // Boxing Day

  // 2026
  '2026-01-01', // New Year's Day
  '2026-01-02', // 2nd Jan (Scotland)
  '2026-03-17', // St Patrick's Day (Northern Ireland)
  '2026-04-03', // Good Friday
  '2026-04-06', // Easter Monday
  '2026-05-04', // Early May bank holiday
  '2026-05-25', // Spring bank holiday
  '2026-07-13', // Battle of the Boyne (substitute) - Northern Ireland
  '2026-08-03', // Summer bank holiday (Scotland)
  '2026-08-31', // Summer bank holiday (England/Wales/Northern Ireland)
  '2026-11-30', // St Andrew's Day (Scotland)
  '2026-12-25', // Christmas Day
  '2026-12-28', // Boxing Day (substitute)

  // 2027
  // TODO: Complete 2027 non-delivery dates
  '2027-01-01', // New Year's Day
  '2027-01-04', // 2nd Jan (Scotland)
  '2027-03-17', // St Patrick's Day (Northern Ireland)
  '2027-03-26', // Good Friday
  '2027-03-29', // Easter Monday
];

//Exclude Scotland and Northern Ireland bank holidays for testing purposes
export const NonDeliveryDatesTest3: string[] = [
  // 2026
  '2026-01-01', // New Year's Day
  '2026-04-03', // Good Friday
  '2026-04-06', // Easter Monday
  '2026-05-04', // Early May bank holiday
  '2026-05-25', // Spring bank holiday
  '2026-08-31', // Summer bank holiday (England/Wales/Northern Ireland)
  '2026-12-25', // Christmas Day
  '2026-12-26', // Boxing Day (Royal Mail)
  '2026-12-28', // Boxing Day (substitute)

  // 2027
  '2027-01-01', // New Year's Day
  '2027-03-26', // Good Friday
  '2027-03-29', // Easter Monday
  '2027-05-03', // Early May bank holiday
  '2027-05-31', // Spring bank holiday
  '2027-08-30', // Summer bank holiday (England/Wales/Northern Ireland)
  '2027-12-25', // Christmas Day (Royal Mail)
  '2027-12-26', // Boxing Day (Royal Mail)
  '2027-12-27', // Christmas Day (substitute)
  '2027-12-28', // Boxing Day (substitute)
];
